module.exports = __webpack_public_path__ + "static/media/No_Wifi.e390eb92.png";